module.exports = __webpack_public_path__ + "media/images/favicon/favicon-310-4c1f9335054c83ccc263c52ec0bf81f5.png";